module.exports = __webpack_public_path__ + "static/media/1. Success.0add1804.svg";